import { getNoteInvalidateTag, getVehicleActivityLogNotesTag } from 'features/notes/notesSlice';
import { baseApi } from '../../app/baseApi';
import { baseQuery } from "../../app/baseQuery";
import { apiTags } from '../../app/store/apiTags';
import { NoteEntityTypes } from "features/notes/notesConsts";
import moment from 'moment';
import { activityStatuses } from './activityConsts';

const apiPrefix = 'activity';
export const activityApi = baseApi.injectEndpoints({
    reducerPath: 'activityApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getAllActivityTypes: builder.query({
            query: () => `activitytype`,
            providesTags: [apiTags.ACTIVITY_TYPES]
        }),
        getAllActivitiesItemByTypeId: builder.query({
            query: (activitytypeid) => `activityitem/${activitytypeid}`,
        }),
        getActivityTypePriceByItemId: builder.query({
            query: (activityitemid) => `activitytypeprice/${activityitemid}`,
        }),
        getAllActivities: builder.query({
            query: () => `${apiPrefix}`,
            providesTags: [apiTags.ACTIVITIES]
        }),
        // getActivityStatuses: builder.query({
        //     query: () => `vehicle/activitystatuses`,
        // }),
        getAllActivityItems: builder.query({
            query: () => `activityitem`,
            providesTags: [apiTags.ACTIVITY_ITEM]
        }),
        getImportTemplate: builder.mutation({
            query: () => ({
                url: `activitylog/downloadtemplate`,
                method: "GET",
                responseHandler: async (response) => {
                    const filename = 'Import activities template.csv';
                    const url = window.URL.createObjectURL(await response.blob());
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    link.click();
                },
                cache: "no-cache"
            })
        }),
        updateActivityLog: builder.mutation({
            query: activityLog => ({
                url: `${apiPrefix}`,
                method: "PUT",
                body: activityLog
            }),
            invalidatesTags: (result, error, arg) => [
                "Tasks",
                getVehicleActivityLogNotesTag(),
                getNoteInvalidateTag(arg.id, NoteEntityTypes.ACTIVITY),
                apiTags.MECHANICAL_ACTIVITIES,
                apiTags.ACTIVITY_TYPE_INVENTORY,
                apiTags.MECHANICAL_TASK,
                apiTags.VEHICLE,
                apiTags.ACTIVITY_LOG,
                apiTags.ACTIVITY_LOG_MATERIALS,
                apiTags.READINESS,
                apiTags.ACTIVITY_FEED_LOG
            ],
        }),
        addActivity: builder.mutation({
            query: activityLog => ({
                url: `${apiPrefix}`,
                method: "POST",
                body: activityLog
            }),
            invalidatesTags: (result, error, arg) => [
                "Tasks",
                "Readiness",
                getVehicleActivityLogNotesTag(),
                apiTags.MECHANICAL_ACTIVITIES,
                apiTags.ACTIVITY_TYPE_INVENTORY,
                apiTags.VEHICLE,
                apiTags.ACTIVITY_LOG,
                apiTags.ACTIVITY_LOG_MATERIALS,
                apiTags.ACTIVITY_FEED_LOG
            ],
        }),
        deleteActivity: builder.mutation({
            query: id => ({
                url: `activitylog/delete`,
                method: "POST",
                body: { activityLogId: id }
            }),
            invalidatesTags: ["Tasks", "Vehicle", apiTags.READINESS]
        }),
        importActivities: builder.mutation({
            query: activities => ({
                url: `activitylog/import`,
                method: "POST",
                body: activities
            }),
        }),
        // approvePendingApproval: builder.mutation({
        //     query: ({ activityLogId, price, revenue }) => ({
        //         url: `${apiPrefix}/approve/pendingApproval`,
        //         method: "POST",
        //         body: {
        //             activityLogId,
        //             revenue,
        //             price
        //         }
        //     }),
        //     invalidatesTags: [apiTags.MECHANICAL_ACTIVITIES]
        // }),
        approvePendingInvoice: builder.mutation({
            query: ({ activityLogIds, price, revenue }) => ({
                url: `${apiPrefix}/approve/pendingInvoice`,
                method: "POST",
                body: {
                    activityLogIds,
                    revenue,
                    price
                }
            }),
            invalidatesTags: [apiTags.MECHANICAL_ACTIVITIES]
        }),
        moveToStatus: builder.mutation({
            query: ({ activityLogIds, moveToStatus, reasonId, vendorId, cost, charge, requestedCompletionDate, offSiteWork, noCharge, repairOrder, note, approverName, activityDate }) => ({
                url: `${apiPrefix}/moveToStatus`,
                method: "POST",
                body: {
                    activityLogIds,
                    moveToStatus,
                    reasonId,
                    vendorId,
                    cost,
                    charge,
                    requestedCompletionDate,
                    offSiteWork,
                    noCharge,
                    repairOrder,
                    note,
                    approverName,
                    activityDate
                }
            }),
            invalidatesTags: [apiTags.MECHANICAL_ACTIVITIES, apiTags.MECHANICAL_TASK, apiTags.ACTIVITY_LOG, apiTags.NOTES, apiTags.READINESS, apiTags.ACTIVITY_FEED_LOG]
        }),
        confirmActivityPrice: builder.mutation({
            query: ({ activityLogId, confirmed }) => ({
                url: `${apiPrefix}/confirmPrice`,
                method: "POST",
                body: {
                    activityLogId,
                    confirmed
                }
            }),
            invalidatesTags: [apiTags.MECHANICAL_ACTIVITIES, apiTags.ACTIVITY_LOG]
        }),
        addActivityType: builder.mutation({
            query: activityType => ({
                url: `activityItem`,
                method: "POST",
                body: activityType
            }),
            invalidatesTags: [apiTags.ACTIVITY_ITEM, apiTags.ACTIVITY_TYPES, apiTags.MECHANICAL_RULE_TYPES]
        }),
        getActivityFieldsTypes: builder.query({
            query: () => `activityItem/fieldTypes`,
        }),
        updateActivityType: builder.mutation({
            query: activityType => ({
                url: `activityItem/update`,
                method: "PUT",
                body: activityType
            }),
            invalidatesTags: [
                apiTags.ACTIVITY_ITEM,
                apiTags.ACTIVITY_TYPES,
                apiTags.MECHANICAL_RULE_TYPES,
                apiTags.ACTIVITY_ITEM_MATERIAL
            ]
        }),
        canDelete: builder.mutation({
            query: (id) => ({
                url: `activityItem/candelete/${id}`,
                method: "GET",
            }),
        }),
        deleteActivityType: builder.mutation({
            query: (id, canDelete) => ({
                url: `activityitem/delete`,
                method: "PUT",
                body: { Id: id, canDelete: canDelete }
            }),
            invalidatesTags: [apiTags.ACTIVITY_ITEM, apiTags.ACTIVITY_TYPES, apiTags.MECHANICAL_RULE_TYPES]
        }),
        addActivityTypeInventoryConfiguration: builder.mutation({
            query: activityTypeInventoryConfiguration => ({
                url: `activityType/activityTypeInventoryConfiguration`,
                method: "POST",
                body: activityTypeInventoryConfiguration
            }),
            invalidatesTags: (result, error, arg) => [apiTags.ACTIVITY_TYPES, apiTags.MECHANICAL_RULE_TYPES],
        }),
        getAllActivityTypeInventoryConfigs: builder.query({
            query: () => `activitytype/activityTypeInventorySettings`,
            providesTags: [apiTags.ACTIVITY_TYPES]
        }),
        getAllStepsToCompleteConfig: builder.query({
            query: () => `activitytype/stepsToCompleteConfiguration`,
            providesTags: [apiTags.ACTIVITY_TYPES]
        }),
        getMechanicalActivities: builder.query({
            query: (params) => params?.includeCleaning ? `mechanicals/activities?includeCleaning=true` : `mechanicals/activities`,
            providesTags: [apiTags.MECHANICAL_ACTIVITIES],
            transformResponse: (response) => {
                return response.map(activity => ({
                    ...activity,
                    activityMonth: moment(activity.activityDate).format('YYYYMM')
                }));
            }
        }),
        getWashActivities: builder.query({
            query: (params) => {
                const queryString = new URLSearchParams(params).toString();
                return `mechanicals/activities/washes?${queryString}`;
            },
            providesTags: [apiTags.MECHANICAL_ACTIVITIES],
            transformResponse: (response) => {
                let completedActivities = [];
                let exceptionActivities = [];
                let allActivities = [];
                response?.map(activity => {
                    if (activity?.activityId === activityStatuses.PendingInvoice ||
                        activity?.activityId === activityStatuses.Completed ||
                        activity?.activityId === activityStatuses.CompleteBilling ||
                        activity?.activityId === activityStatuses.CompletedAndPaid) {
                        completedActivities.push(activity);
                    }
                    else if (activity?.activityId === activityStatuses.Exception) {
                        exceptionActivities.push(activity);
                    }
                    allActivities.push(activity);
                });
                return { completedActivities, exceptionActivities, allActivities };
            }
        }),
        getWorkOrderInfo: builder.query({
            query: (workOrderId) => `mechanicals/workOrderInfo?workOrderId=${workOrderId}`,
            providesTags: [apiTags.MECHANICAL_TASK]
        }),
        getAllActivityItemsWithCustomFields: builder.query({
            query: () => `activityitem/customFields`,
            providesTags: [apiTags.ACTIVITY_ITEM]
        }),
        getWorkOrderCustomData: builder.query({
            query: (workOrderId) => `activityLog/customData/${workOrderId}`,
            providesTags: [apiTags.ACTIVITY_LOG]
        }),
        getWorkordersForVehicle: builder.query({
            query: ({ vehicleId }) => `activityLog/workorders?vehicleId=${vehicleId}`
        }),
        getActivityStatusReasons: builder.query({
            query: () => `activityLog/reasons`,
            transformResponse: (response) => {
                return response.map(reason => ({
                    ...reason,
                    name: reason?.reasonText
                }))?.sort((a, b) => a?.name?.localeCompare(b?.name));
            }
        }),
        getActivitiesByParams: builder.query({
            query: ({ clientId, lotId, startDate, endDate }) => `activityLog/params?clientId=${clientId}&lotId=${lotId}&startDate=${startDate}&endDate=${endDate}`
        }),
        getActivityItemMaterials: builder.query({
            query: (activityItemId) => `activityitem/materials/${activityItemId}`,
            providesTags: [apiTags.ACTIVITY_ITEM_MATERIAL]
        }),
        getAllActivityItemMaterials: builder.query({
            query: () => `activityitem/materials`,
            providesTags: [apiTags.ACTIVITY_ITEM_MATERIAL]
        }),
        getActivityLogMaterials: builder.query({
            query: (workOrderId) => `activityLog/materials/${workOrderId}`,
            providesTags: [apiTags.ACTIVITY_LOG_MATERIALS]
        }),
        getActivityFeedLogByWorkOrderId: builder.query({
            query: (workOrderId) => `activityFeedLog/${workOrderId}`,
            providesTags: [apiTags.ACTIVITY_FEED_LOG],
            transformResponse: (response) => Array.isArray(response) ? response : (response?.data ?? [])
        }),
        getTimeInStatusThresholds: builder.query({
            query: () => `mechanicals/timeInStatusThresholds`,
            providesTags: [apiTags.TIME_IN_STATUS_THRESHOLDS]
        }),
        updateTimeInStatusThresholds: builder.mutation({
            query: (thresholds) => ({
                url: `mechanicals/timeInStatusThresholds`,
                method: "PUT",
                body: { thresholds }
            }),
            invalidatesTags: [apiTags.TIME_IN_STATUS_THRESHOLDS]
        }),
    }),
});

export const { useGetAllActivityTypesQuery,
    useGetAllActivitiesItemByTypeIdQuery,
    useGetActivityTypePriceByItemIdQuery,
    useGetAllActivitiesQuery,
    useGetAllActivityItemsQuery,
    useGetAllActivityLogsQuery,
    useGetImportTemplateMutation,
    useUpdateActivityLogMutation,
    useAddActivityMutation,
    useDeleteActivityMutation,
    useImportActivitiesMutation,
    // useApprovePendingApprovalMutation,
    useApprovePendingInvoiceMutation,
    useConfirmActivityPriceMutation,
    useAddActivityTypeMutation,
    useGetActivityFieldsTypesQuery,
    useUpdateActivityTypeMutation,
    useCanDeleteMutation,
    useDeleteActivityTypeMutation,
    useAddActivityTypeInventoryConfigurationMutation,
    useGetAllActivityTypeInventoryConfigsQuery,
    useGetAllStepsToCompleteConfigQuery,
    useMoveToStatusMutation,
    useGetMechanicalActivitiesQuery,
    useGetWashActivitiesQuery,
    useGetWorkOrderInfoQuery,
    useGetAllActivityItemsWithCustomFieldsQuery,
    useGetWorkOrderCustomDataQuery,
    useGetWorkordersForVehicleQuery,
    useGetActivityStatusReasonsQuery,
    useGetActivitiesByParamsQuery,
    useGetActivityItemMaterialsQuery,
    useGetAllActivityItemMaterialsQuery,
    useGetActivityLogMaterialsQuery,
    useGetActivityFeedLogByWorkOrderIdQuery,
    useGetTimeInStatusThresholdsQuery,
    useUpdateTimeInStatusThresholdsMutation
} = activityApi;
